import React from 'react';
import { StartupListPage } from './list';

export const StartupModule = () => {
  return <StartupListPage />;
};
